import { render, staticRenderFns } from "./CaBc.vue?vue&type=template&id=27ed4056&scoped=true&"
import script from "./CaBc.vue?vue&type=script&lang=js&"
export * from "./CaBc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed4056",
  null
  
)

export default component.exports